import { Icon } from '@types';

export const Work = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			onClick={handleClick}
			className={customStyles}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 63.79 76.8"
		>
			<defs>
				<style>
					{
						'.cls-work{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
					}
				</style>
			</defs>
			<path
				className="cls-work"
				d="M53.03,56.29s-5.58,9.16-5.58,13.54c0,5.06,3.98,5.97,5.58,5.97s5.58-.91,5.58-5.97c0-4.38-5.58-13.54-5.58-13.54Z"
			/>
			<line className="cls-work" x1={7.5} y1={30.27} x2={1} y2={30.27} />
			<path className="cls-work" d="M46.53,41.65v-7.46c0-2.17-1.76-3.93-3.93-3.93h-10.71" />
			<path className="cls-work" d="M30.27,17.26h12.77c9.11,0,16.49,7.38,16.49,16.49v7.9" />
			<line className="cls-work" x1={1} y1={17.26} x2={7.5} y2={17.26} />
			<rect
				className="cls-work"
				x={7.5}
				y={15.63}
				width={22.77}
				height={16.26}
				rx={1.36}
				ry={1.36}
			/>
			<polyline
				className="cls-work"
				points="46.53 41.65 43.28 41.65 43.28 51.41 62.79 51.41 62.79 41.65 54.66 41.65"
			/>
			<rect className="cls-work" x={10.76} y={1} width={16.26} height={6.5} />
			<line className="cls-work" x1={18.89} y1={15.63} x2={18.89} y2={7.5} />
		</svg>
	);
};
